<template>
  <app-page :title="$t('@reportsPage/title')">
    <v-layout>
      <v-flex xs12>
        <v-card flat>
          <v-card-text class="pa-4">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              lazy
              full-width
              width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date"
                :label="$t('@reportsPage/monthFilterDatepickerLabel')"
                readonly
              ></v-text-field>
              <v-date-picker v-model="date" :max="maxDate" type="month" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal = false">
                  {{ $t('@reportsPage/monthFilterDatepickerCancelButtonLabel') }}
                </v-btn>
                <v-btn flat color="primary" @click="$refs.dialog.save(date)">
                  {{ $t('@reportsPage/monthFilterDatepickerSubmitButtonLabel') }}
                </v-btn>
              </v-date-picker>
            </v-dialog>

            <v-layout>
              <v-flex xs6 class="pr-2">
                <v-select
                  :items="reportTypes"
                  v-model="selectedReportType"
                  :label="$t('@reportsPage/reportTypeSelectLabel')"
                  item-value="value"
                  item-text="key"
                  return-object
                ></v-select>
              </v-flex>

              <v-flex xs6 class="pl-2">
                <v-select
                  :items="productGroups"
                  v-model="selectedProductGroup"
                  :label="$t('@reportsPage/productGroupSelectLabel')"
                  item-value="value"
                  item-text="key"
                  return-object
                  :disabled="!canSelectProduct"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn flat color="pink" :href="downloadUrl" :disabled="!downloadEnabled">
              {{ $t('@reportsPage/downloadReportButtonLabel') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </app-page>
</template>

<script>
import moment from 'moment';
import { serializeQuery } from '../../utils';

const REQUEST_QUERY_DATE_FORMAT = 'YYYY-MM-DD';

export default {
  data() {
    return {
      modal: null,
      date: null,
      selectedReportType: null,
      selectedProductGroup: null,
      productGroups: [
        { key: this.$t('@reportsPage/productGroupSelectTfOption'), value: 'TF' },
        { key: this.$t('@reportsPage/productGroupSelectOfOption'), value: 'OF' },
        { key: this.$t('@reportsPage/productGroupSelectSfOption'), value: 'SF' },
        { key: this.$t('@reportsPage/productGroupSelectOfNewOption'), value: 'OFNew' },
      ],
      reportTypes: [
        { header: this.$t('@reportsPage/reportTypeSelectInsurancesGroupTitle') },
        { divider: true },
        {
          key: this.$t('@reportsPage/reportTypeSelectUnpaidInsurancesOption'),
          value: 'unpaid',
          withProduct: true,
        },
        {
          key: this.$t('@reportsPage/reportTypeSelectAcceptedInsurancesOption'),
          value: 'accepted',
          withProduct: true,
        },
        {
          key: this.$t('@reportsPage/reportTypeSelectTerminatedInsurancesOption'),
          value: 'terminated',
          withProduct: true,
        },
        {
          key: this.$t('@reportsPage/reportTypeSelectTransactionsInsurancesOption'),
          value: 'transactions',
          withProduct: true,
        },
        { divider: true },
        { header: this.$t('@reportsPage/reportTypeSelectEmployeesGroupTitle') },
        {
          key: this.$t('@reportsPage/reportTypeSelectAdvisorEmployeesOption'),
          value: 'advisor',
          withProduct: false,
        },
        { header: this.$t('@reportsPage/reportTypeSelectInsuranceCompanyEmployeesGroupTitle') },
        {
          key: this.$t(
            '@reportsPage/reportTypeSelectMonthlySummaryInsuranceCompanyEmployeesOption',
          ),
          value: 'accounting',
          withProduct: true,
        },
        {
          key: this.$t('@reportsPage/reportTypeSicknessOption'),
          value: 'sickness',
          withProduct: false,
        },
      ],
    };
  },

  watch: {
    selectedReportType(val) {
      if (val && !val.withProduct && this.selectedProductGroup) {
        this.selectedProductGroup = null;
      }
    },
  },

  computed: {
    maxDate() {
      const date = new Date();
      const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);

      if (process.env.VUE_APP_REPORTS_MAX_DATE === 'false') {
        return '';
      }
      return nextMonth.toISOString().substring(0, 7);
    },

    downloadEnabled() {
      return (
        this.date &&
        this.selectedReportType &&
        (this.canSelectProduct ? this.selectedProductGroup : true)
      );
    },

    canSelectProduct() {
      return this.selectedReportType && this.selectedReportType.withProduct;
    },

    downloadUrl() {
      if (!this.downloadEnabled) {
        return;
      }

      const from = moment(this.date)
        .startOf('month')
        .format(REQUEST_QUERY_DATE_FORMAT);
      const to = moment(this.date)
        .add(1, 'month')
        .startOf('month')
        .format(REQUEST_QUERY_DATE_FORMAT);
      const query = { from, to };

      if (this.selectedProductGroup) {
        query.product = this.selectedProductGroup.value;
      }

      return `/api/report/${this.selectedReportType.value}?${serializeQuery(query)}`;
    },
  },

  methods: {},
};
</script>
